/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/img-redundant-alt */

import React, { useState } from 'react';

import Logo from 'assets/images/logo-conlicitacao-dark.png';
import IconTeacher from 'assets/images/teacher_icon.svg';
import IconPuzzle from 'assets/images/puzzle_icon.svg';
import IconScale from 'assets/images/scale_icon.svg';
import IconTools from 'assets/images/icon_tools.svg';
import ImgMercado from 'assets/images/mercado-register.png';
import ImgDepoimento from 'assets/images/img_depoimento_register.svg';
import BgSessionCnl from 'assets/images/bg-session-conlicitacao-register.png';
import IconConhecimento from 'assets/images/colored_icons/icon_conhecimento.svg';
import IconHabilitacao from 'assets/images/colored_icons/icon_habilitacao.svg';
import IconDocumentacao from 'assets/images/colored_icons/icon_documentacao.svg';
import IconSegmento from 'assets/images/colored_icons/icon_segmento.svg';
import IconSuporte from 'assets/images/colored_icons/icon_suporte.svg';
import IconEstrela from 'assets/images/colored_icons/circulo_estrela.svg';
import Bandeiras from 'assets/images/bandeiras_register.png';
import Medalha from 'assets/images/7-days.svg';
import IconEncontrarLicitacoes from 'assets/images/encontrar_licitacoes.svg';
import IconBoletinsDiarios from 'assets/images/boletins_diarios.svg';
import IconGerenciamentoDocumentos from 'assets/images/gerenciamento_doc.svg';
import IconAnaliseConcorrencia from 'assets/images/analise_conc.svg';
import IconAnaliseMercado from 'assets/images/analise_mer.svg';
import IconAssessoriaCadastral from 'assets/images/asses_cadastral.svg';
import IconConsultoriaJuridica from 'assets/images/consult_jur.svg';
import IconMeuHistorico from 'assets/images/meu_hist.svg';
import IconLicitacoesEstrategicas from 'assets/images/lic_estrat.svg';
import IconContratos from 'assets/images/contratos.svg';
import IconJuridicoFacil from 'assets/images/juri_facil.svg';
import { register_checkout_access } from 'services/actions/update_register_beginner';
import { openSupportChat } from 'services/support_chat';
import CheckoutSaleRegister from '../checkout_sale_register';
import { Container } from './styles';

const RegisterBeginner = () => {
  const [beginner, setBeginner] = useState<boolean>(false);

  if (beginner) {
    return <CheckoutSaleRegister typeClient="beginner" />;
  }

  const handleClick = async () => {
    (async () => {
      await register_checkout_access();
    })();

    setBeginner(true);
  };

  return (
    <Container className="w-100">
      <div className="w-100 bg-img">
        <div className="container mt-5">
          <div className="row mt-5">
            <div className="col-md-12 text-left mt-3">
              <img
                className="card-img-top mt-2"
                src={Logo}
                alt="ConLicitação"
                style={{ width: '230px' }}
              />
            </div>
          </div>
        </div>

        <div className="container mt-4">
          <div className="row mb-3">
            <div className="col-md-6">
              <h1>Aprenda a vender para o governo de forma segura e alcance novos mercados</h1>

              <h2 className="mb-4">
                Nós temos a solução perfeita para você iniciar no mundo das licitações e conquistar
                seus primeiros contratos com o governo
              </h2>

              <a href="#prace_page" className="button-comprar mt-2">
                QUERO VENDER PARA O GOVERNO
              </a>
            </div>
          </div>

          <div className="row mt-5">
            <div className="col-md-12">
              <p>CONHEÇA NOSSO PLANO DE ASSINATURA</p>

              <h3>Introdução ao Mundo das Licitações</h3>

              <div className="card-deck text-center mt-5">
                <div className="card">
                  <div className="card-body">
                    <img src={IconTeacher} alt="Teacher" width={120} />

                    <h5 className="card-title mt-3">Treinamento</h5>
                  </div>
                </div>

                <p className="p-separador">+</p>

                <div className="card">
                  <div className="card-body">
                    <img src={IconPuzzle} alt="Card image cap" width={120} />

                    <h5 className="card-title mt-3">Oportunidades de licitação</h5>
                  </div>
                </div>

                <p className="p-separador">+</p>

                <div className="card">
                  <div className="card-body">
                    <img src={IconTools} alt="Card image cap" width={120} />

                    <h5 className="card-title mt-3">Ferramentas estratégicas</h5>
                  </div>
                </div>

                <p className="p-separador">+</p>

                <div className="card">
                  <div className="card-body">
                    <img src={IconScale} alt="Card image cap" width={120} />

                    <h5 className="card-title mt-3">Suporte Jurídico</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 text-center mt-5">
              <p className="title">
                Tudo que você precisa para <br /> começar a vender para o governo
              </p>

              <p className="subTitle">
                Assista o video a seguir para conhecer nosso plano de <br /> assinatura:
                <strong> Introdução ao Mundo das Licitações</strong>
              </p>

              <iframe
                width="560"
                height="315"
                src="https://player.vimeo.com/video/803610280"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />

              <p className="subTitle mt-3">
                Descubra como superar a burocracia e compreender as etapas de uma venda eficaz
                <br /> com o apoio de especialistas líderes no mercado há mais de 20 anos.
              </p>

              <a href="#prace_page" className="button-comprar">
                QUERO CONTRATAR AGORA
              </a>

              <br />

              <img src={Bandeiras} alt="Bandeiras" className="mt-5" />
            </div>
          </div>
        </div>

        <div className="container mt-5">
          <div className="row">
            <div className="col-md-12">
              <p className="mercado-licitacao">
                Domine o mercado de licitações e <br />
                encontre novas fontes de faturamento
              </p>

              <p className="mercado-subtitle mb-5">
                O que você vai alcançar contratando este plano
              </p>

              <div className="row">
                <div className="col-md-7">
                  <div className="row">
                    <div className="col-md-2">
                      <img src={IconConhecimento} alt="Conhecimento" style={{ width: '90px' }} />
                    </div>

                    <div className="col-md-10">
                      <p className="font-weight-bold card-title">Conhecimento na prática</p>

                      <p className="mb-0 card-subtitle">
                        Você compreenderá o passo a passo de todas as etapas necessárias para
                        concretizar uma venda com o Governo.
                      </p>
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col-md-2">
                      <img src={IconHabilitacao} alt="Habilitação" style={{ width: '90px' }} />
                    </div>

                    <div className="col-md-10">
                      <p className="font-weight-bold card-title">Credenciamento e habilitação</p>

                      <p className="mb-0 card-subtitle">
                        Saiba como credenciar sua empresa para participar de qualquer licitação que
                        identificar como potencial.
                      </p>
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col-md-2">
                      <img src={IconDocumentacao} alt="Documentação" style={{ width: '90px' }} />
                    </div>

                    <div className="col-md-10">
                      <p className="font-weight-bold card-title">Documentação descomplicada</p>

                      <p className="mb-0 card-subtitle">
                        Você terá acesso ao caminho para obter toda a documentação adequada para
                        vender ao governo.
                      </p>
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col-md-2">
                      <img src={IconSegmento} alt="Segmento" style={{ width: '90px' }} />
                    </div>

                    <div className="col-md-10">
                      <p className="font-weight-bold card-title">
                        Acesso às oportunidades do seu segmento
                      </p>

                      <p className="mb-0 card-subtitle">
                        Receba somente oportunidades do seu perfil, economizando tempo e garantindo
                        acesso a todas as oportunidades em potencial.
                      </p>
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col-md-2">
                      <img src={IconSuporte} alt="Calendar" style={{ width: '90px' }} />
                    </div>

                    <div className="col-md-10">
                      <p className="font-weight-bold card-title">Suporte de especialistas</p>

                      <p className="mb-0 card-subtitle">
                        Conte com auxílio dos especialistas do ConLicitação para te ajudar em todas
                        as etapas do processo licitatório.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-md-5">
                  <img src={ImgMercado} alt="Mercado" width={500} />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid bg-mercado">
          <div className="row">
            <div className="col-md-12">
              <div className="container">
                <div className="row margin">
                  <div className="col-md-12">
                    <p className="mercado-licitacao text-right">
                      Se você busca expandir seus negócios, <br /> essa é a solução certa para você!
                    </p>

                    <div className="row">
                      <div className="col-md-3" />

                      <div className="col-md-9 p-0">
                        <div className="card-deck ml-0">
                          <div className="card m-0">
                            <div className="card-body p-2">
                              <h5 className="card-title title-number">1.</h5>

                              <p className="card-title">Curso completo de licitação</p>

                              <p className="card-text">
                                "Licitação do Zero" para capacitá-lo a participar de licitações e
                                começar a vender para o governo
                              </p>
                            </div>
                          </div>

                          <div className="card">
                            <div className="card-body p-2">
                              <h5 className="card-title title-number">2.</h5>

                              <p className="card-title">Oportunidades de vendas</p>

                              <p className="card-text">
                                Acesso diário às oportunidades de vendas, filtradas de acordo com o
                                seu segmento e área de atuação
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-4 mb-5">
                      <div className="col-md-3" />

                      <div className="col-md-9 p-0">
                        <div className="card-deck ml-0">
                          <div className="card m-0">
                            <div className="card-body p-2">
                              <h5 className="card-title title-number">3.</h5>

                              <p className="card-title">Especialistas à disposição</p>

                              <p className="card-text">
                                Consultoria técnica e jurídica para você atuar com segurança e sanar
                                qualquer dúvida que possa surgir.
                              </p>
                            </div>
                          </div>

                          <div className="card">
                            <div className="card-body p-2">
                              <h5 className="title-number">4.</h5>

                              <p className="card-title">ConLicitação ao seu lado</p>

                              <p className="card-text">
                                Todo apoio e orientação necessária para aproveitar ao máximo todas
                                as ferramentas e recursos disponíveis
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row mt-5 px-5">
            <div className="col-md-12">
              <p className="mercado-licitacao mb-0">
                Tenha acesso completo a plataforma ConLicitação
              </p>

              <h4 className="mercado-subtitle mt-0 mb-5">Ferramentas estratégicas</h4>

              <div className="row">
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-2">
                      <img
                        src={IconEncontrarLicitacoes}
                        alt="Encontrar Licitacoes"
                        style={{ width: '58px' }}
                      />
                    </div>

                    <div className="col-md-6">
                      <p className="font-weight-bold p-description mb-0">Encontrar Licitações </p>

                      <p className="mt-0">
                        Consulte as licitações do seu interesse em um só lugar.
                      </p>
                    </div>
                  </div>

                  <hr className="mt-0" />
                </div>

                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-2">
                      <img
                        src={IconAssessoriaCadastral}
                        alt="Assessoria Cadastral"
                        style={{ width: '58px' }}
                      />
                    </div>

                    <div className="col-md-8">
                      <p className="font-weight-bold p-description mb-0">Assessoria cadastral </p>

                      <p className="mt-0">
                        Faça seus cadastros nos órgãos públicos sem dificuldades
                      </p>
                    </div>
                  </div>

                  <hr className="mt-0" />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-2">
                      <img src={IconBoletinsDiarios} alt="Boletins" style={{ width: '58px' }} />
                    </div>

                    <div className="col-md-6">
                      <p className="font-weight-bold p-description mb-0">Boletins Diários </p>

                      <p className="mt-0">
                        Receba diariamente avisos de licitações, alterações e resultados.
                      </p>
                    </div>
                  </div>

                  <hr className="mt-0" />
                </div>

                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-2">
                      <img
                        src={IconConsultoriaJuridica}
                        alt="Consultoria Juridica"
                        style={{ width: '58px' }}
                      />
                    </div>

                    <div className="col-md-8">
                      <p className="font-weight-bold p-description mb-0">Consultoria jurídica</p>

                      <p className="mt-0">
                        Entenda toda a parte jurídica para a participação da sua empresa em
                        licitações
                      </p>
                    </div>
                  </div>

                  <hr className="mt-0" />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-2">
                      <img
                        src={IconGerenciamentoDocumentos}
                        alt="Gerenciamento de documentos"
                        style={{ width: '58px' }}
                      />
                    </div>

                    <div className="col-md-7">
                      <p className="font-weight-bold p-description mb-0">
                        Gerenciamento de documentos
                      </p>

                      <p className="mt-0">
                        Administre toda a documentação necessária para ser habilitado em licitações
                      </p>
                    </div>
                  </div>

                  <hr className="mt-0" />
                </div>

                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-2">
                      <img
                        src={IconMeuHistorico}
                        alt="Assessoria CadastralMeu histórico"
                        style={{ width: '58px' }}
                      />
                    </div>

                    <div className="col-md-6">
                      <p className="font-weight-bold p-description mb-0">Meu histórico</p>

                      <p className="mt-0">
                        Tenha uma visão completa das licitações que você participou
                      </p>
                    </div>
                  </div>

                  <hr className="mt-0" />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-2">
                      <img
                        src={IconEncontrarLicitacoes}
                        alt="Encontrar Licitacoes"
                        style={{ width: '58px' }}
                      />
                    </div>

                    <div className="col-md-10">
                      <p className="font-weight-bold p-description mb-0">
                        Gerenciamento de licitações
                      </p>

                      <p className="mt-0">Administre várias licitações ao mesmo tempo </p>
                    </div>
                  </div>

                  <hr className="mt-0" />
                </div>

                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-2">
                      <img
                        src={IconLicitacoesEstrategicas}
                        alt="Licitações Estratégicas"
                        style={{ width: '58px' }}
                      />
                    </div>

                    <div className="col-md-6">
                      <p className="font-weight-bold p-description mb-0">Licitações Estratégicas</p>

                      <p className="mt-0">
                        Encontre licitações com pouca concorrência em seu segmento
                      </p>
                    </div>
                  </div>

                  <hr className="mt-0" />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-2">
                      <img
                        src={IconAnaliseMercado}
                        alt="Análise da concorrência"
                        style={{ width: '58px' }}
                      />
                    </div>

                    <div className="col-md-10">
                      <p className="font-weight-bold p-description mb-0">Análise de mercado</p>

                      <p className="mt-0">
                        Entenda o mercado e crie estratégias para fazer a sua empresa crescer
                      </p>
                    </div>
                  </div>

                  <hr className="mt-0" />
                </div>

                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-2">
                      <img src={IconContratos} alt="Contratos" style={{ width: '58px' }} />
                    </div>

                    <div className="col-md-10">
                      <p className="font-weight-bold p-description mb-0">
                        Contratos e Atas de Registro de Preço
                      </p>

                      <p className="mt-0">
                        Veja os detalhes dos Contratos e Atas celebrados pelo órgão
                      </p>
                    </div>
                  </div>

                  <hr className="mt-0" />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-2">
                      <img
                        src={IconAnaliseConcorrencia}
                        alt="Análise da concorrência"
                        style={{ width: '58px' }}
                      />
                    </div>

                    <div className="col-md-10">
                      <p className="font-weight-bold p-description mb-0">Análise da concorrência</p>

                      <p className="mt-0">Saiba o que os seus concorrentes estão fazendo</p>
                    </div>
                  </div>

                  <hr className="mt-0" />
                </div>

                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-2">
                      <img src={IconJuridicoFacil} alt="Jurídico Fácil" style={{ width: '58px' }} />
                    </div>

                    <div className="col-md-10">
                      <p className="font-weight-bold p-description mb-0">Jurídico Fácil</p>

                      <p className="mt-0">
                        Acesso rápido às respostas para as dúvidas mais comuns nas licitações
                      </p>
                    </div>
                  </div>

                  <hr className="mt-0" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row mt-5">
            <div className="col-md-12">
              <p className="mercado-licitacao mb-0">Por que escolher o ConLicitação?</p>

              <p className="mercado-subtitle mt-0 mb-5">Há mais de vinte anos...</p>

              <div className="row">
                <div className="col-md-7">
                  <div className="row">
                    <div className="col-md-2">
                      <img src={IconEstrela} alt="Estrela" style={{ width: '90px' }} />
                    </div>

                    <div className="col-md-10">
                      <p className="font-weight-bold card-title">Experiência comprovada:</p>

                      <p className="mb-0 card-subtitle">
                        Com mais de 20 anos de atuação no mercado, o ConLicitação é líder no
                        segmento de vendas ao governo e tem uma equipe de especialistas altamente
                        capacitados.
                      </p>
                    </div>
                  </div>

                  <div className="row mt-4">
                    <div className="col-md-2">
                      <img src={IconEstrela} alt="Estrela" style={{ width: '90px' }} />
                    </div>

                    <div className="col-md-10">
                      <p className="font-weight-bold card-title">Suporte especializado</p>

                      <p className="mb-0 card-subtitle">
                        Não importa qual seja sua dúvida ou problema, nossa equipe estará sempre
                        disponível para te ajudar e orientar durante todo o processo.
                      </p>
                    </div>
                  </div>

                  <div className="row mt-4">
                    <div className="col-md-2">
                      <img src={IconEstrela} alt="Estrela" style={{ width: '90px' }} />
                    </div>

                    <div className="col-md-10">
                      <p className="font-weight-bold card-title">Ferramentas exclusivas</p>

                      <p className="mb-0 card-subtitle">
                        Com acesso a ferramentas exclusivas, você terá todo o suporte necessário
                        para identificar e aproveitar as melhores oportunidades de vendas ao
                        governo.
                      </p>
                    </div>
                  </div>

                  <div className="row mt-4">
                    <div className="col-md-2">
                      <img src={IconEstrela} alt="Estrela" style={{ width: '90px' }} />
                    </div>

                    <div className="col-md-10">
                      <p className="font-weight-bold card-title">Resultados garantidos</p>

                      <p className="mb-0 card-subtitle">
                        Não importa se você é novo no mercado ou já tem experiência, o ConLicitação
                        garante que você alcançará resultados eficazes e sustentáveis.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-md-5">
                  <img src={BgSessionCnl} alt="Mercado" width={500} />
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr />

        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <p className="mercado-licitacao">Veja o que dizem nossos clientes</p>
            </div>

            <div className="card-deck">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <img src={ImgDepoimento} alt="Depoimento" width={90} />
                    </div>

                    <div className="col-md-9">
                      <h5 className="card-title">Bruna Ladewig</h5>

                      <p>Segline Distribuidora e Importadora de Equipamentos de Seguranca LTDA</p>

                      <p className="card-text">
                        Já são alguns anos trabalhando com o ConLicitação, inclusive, a empresa não
                        estaria hoje competitiva no mercado se não fosse por vocês! Renovamos todo o
                        ano à assinatura com a certeza de receber Boletins de qualidade, filtrados e
                        adequados ao nosso ramo! Além de disponibilizar lives com conteúdos
                        relevantes e análise de mercado! Estamos atuando desde 2003 e hoje,
                        trabalhamos somente com vendas por meio de processos licitatórios. Essa
                        parceria é reconhecida, além de diversas ferramentas disponíveis no painel
                        de assinante, o ConLicitação oferece acesso ao “Bolsa de Empregos”, muito
                        útil para busca de currículos ou vagas! Por isso, deixamos aqui, nosso
                        obrigado!
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <img src={ImgDepoimento} alt="Depoimento" width={90} />
                    </div>

                    <div className="col-md-9">
                      <h5 className="card-title">Terra Perfurações Ltda.</h5>

                      <p className="card-text">
                        O Portal do Grupo ConLicitação é bastante completo, mas ressalta-se o
                        monitoramento e acompanhamento de licitações. As lives informativas são
                        sensacionais e os esclarecimentos são primordiais. Os vídeos com conteúdos
                        informativos e legislatórios são espetaculares. Um diferencial. Em suma: se
                        você quiser obter sucesso e extrair o máximo das licitações, é indispensável
                        assinar o Portal. Parabéns a todos!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="prace_page" className="container-fluid bg-plano">
          <div className="row mt-5">
            <div className="col-md-12">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <p className="mercado-licitacao text-center mt-5">
                      Transforme sua empresa em um fornecedor oficial do <br />
                      governo e aumente seu faturamento com o ConLicitação!
                    </p>
                  </div>
                </div>

                <div className="row mt-4">
                  <div className="col-md-6 acesso">
                    <h3 className="mb-3">
                      <span className="badge badge-dark">PLANO DE ASSINATURA</span>
                    </h3>

                    <p className="font-weight-bold h1">
                      Introdução ao Mundo <br /> das Licitações
                    </p>

                    <p>12 meses de acesso</p>

                    <ul>
                      <li>- Curso Licitação do zero</li>

                      <li>- Certificado de Conclusão</li>

                      <li>- Boletins de Licitações</li>

                      <li>- Encontrar Licitações</li>

                      <li>- Gerenciar Documentos</li>

                      <li>- ConLicitaGO</li>

                      <li>- Consultoria técnica</li>

                      <li>- Consultoria jurídica</li>
                    </ul>

                    <p>
                      Domine a arte de vender para o governo
                      <br /> com nosso plano exclusivo de treinamento, <br />
                      ferramentas e suporte especializado
                    </p>
                  </div>

                  <div className="col-md-6">
                    <div className="card mb-4" style={{ width: '22rem' }}>
                      <div className="card-header font-weight-bold">
                        <h5 className="font-weight-bold mb-0">PLANO INTRODUÇÃO</h5>

                        <div className="row">
                          <div className="col-md-9">
                            <p className="acesso">12 meses de acesso</p>
                          </div>

                          <div className="col-md-3">
                            <h3>
                              <span className="badge badge-success">- 25%</span>
                            </h3>
                          </div>
                        </div>
                      </div>

                      <div className="card-body">
                        <p className="mercado-subtitle mb-0">De</p>

                        <p className="valor mt-0">
                          <s>R$ 3.319,92</s>
                        </p>

                        <p className="mercado-subtitle mb-0">por</p>

                        <p className="valor mb-0">
                          <strong>R$ 2.490,00 </strong>à vista
                        </p>

                        <h6 className="mt-2 mb-4">ou 5x de R$ 448,20 sem juros no cartão</h6>

                        <button type="button" className="button" onClick={() => handleClick()}>
                          COMPRAR PLANO INTRODUÇÃO
                        </button>

                        <p className=" mt-4">
                          <button
                            type="button"
                            className="btn btn-link m-0 p-0 btn-block mt-2"
                            onClick={() => {
                              openSupportChat();
                            }}
                          >
                            <small>Quer habilitar seu periodo de teste?</small>

                            <button
                              type="button"
                              className="button mt-2"
                              onClick={() => {
                                openSupportChat();
                              }}
                            >
                              Fale com consultor
                            </button>
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <hr />
        </div>

        <div className="container">
          <div className="row mt-5">
            <div className="col-md-3">
              <img src={Medalha} alt="7 dias" width={182} />
            </div>

            <div className="col-md-9">
              <h4 className="mercado-subtitle font-weight-bold">7 dias de garantia</h4>

              <p className="card-subtitle">
                Com nosso plano Introdução ao Mundo das Licitações, você tem 7 dias de garantia para
                testar e avaliar se está satisfeito com o conteúdo e ferramentas disponibilizadas.
                Caso não esteja, devolveremos seu investimento sem questionamentos. Confiamos no
                nosso produto e na capacidade dele de ajudar sua empresa a aumentar suas vendas para
                o governo. Experimente agora e veja os resultados por si mesmo.
              </p>
            </div>
          </div>
        </div>

        <hr />

        <div className="container">
          <div className="row mt-5">
            <div className="col-md-12">
              <p className="mercado-licitacao text-center">Perguntas Frequentes</p>

              <div id="accordion">
                <div className="card">
                  <div className="card-header" id="headingOne">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link font-weight-bold"
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        Como o ConLicitação vai me ajudar a vender mais?
                      </button>
                    </h5>
                  </div>

                  <div
                    id="collapseOne"
                    className="collapse show"
                    aria-labelledby="headingOne"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      Nós forneceremos a você as inúmeras oportunidades de vendas que o governo
                      divulga e te ensinaremos como aproveitá-las para vender para o governo.
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="headingTwo">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link collapsed font-weight-bold"
                        data-toggle="collapse"
                        data-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        Como funcionam de oportunidades segmentadas?
                      </button>
                    </h5>
                  </div>

                  <div
                    id="collapseTwo"
                    className="collapse"
                    aria-labelledby="headingTwo"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      Nós selecionamos as oportunidades de vendas diariamente de acordo com o
                      segmento e área de atuação da sua empresa, para economizar o seu tempo e
                      permitir que você se concentre nas vendas.
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="headingThree">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link collapsed font-weight-bold"
                        data-toggle="collapse"
                        data-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        É garantido que vou vender ao governo?
                      </button>
                    </h5>
                  </div>

                  <div
                    id="collapseThree"
                    className="collapse"
                    aria-labelledby="headingThree"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      Não podemos garantir que você venderá ao governo, mas garantimos que você terá
                      acesso às melhores oportunidades de vendas, conhecimento de como aproveitá-las
                      e auxílio dos nossos especialistas em qualquer etapa da venda.
                    </div>
                  </div>
                </div>

                <div className="card mb-5">
                  <div className="card-header" id="headingThree">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link collapsed font-weight-bold"
                        data-toggle="collapse"
                        data-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        Qual é a vantagem desse Plano Especial em relação aos outros oferecidos pelo
                        ConLicitação?
                      </button>
                    </h5>
                  </div>

                  <div
                    id="collapseThree"
                    className="collapse"
                    aria-labelledby="headingThree"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      Esse plano combina a eficiência da nossa plataforma no pacote de serviços
                      básicos com um treinamento exclusivo para que você possa aproveitar ao máximo
                      as oportunidades do mercado público. Além disso, oferecemos suporte completo e
                      especializado durante toda a sua jornada, o que o ajudará a superar qualquer
                      dificuldade e aumentar suas chances de vender para o governo. Ele é
                      especialmente desenvolvido para aqueles que não têm experiência ou se sentem
                      inseguros em fechar contratos com o governo."
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default RegisterBeginner;
